import { render, staticRenderFns } from "./updateTask.vue?vue&type=template&id=1a067214&scoped=true"
import script from "./updateTask.vue?vue&type=script&lang=js"
export * from "./updateTask.vue?vue&type=script&lang=js"
import style0 from "./updateTask.vue?vue&type=style&index=0&id=1a067214&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a067214",
  null
  
)

export default component.exports